import { getPaymentMethodId } from 'shared/utils/subscriptionV2Helpers';
import { SubscriptionDetailsV2Response } from 'state/internal/getSubscriptionDetails/types';
import { isCreditCardExpired } from '@portal/shared/utils/check/isCreditCardExpired';

// determines whether the current subscription details page can display expired payment banner
export const hasExpiringPaymentV2 = (subscription: SubscriptionDetailsV2Response | undefined) => {
  const hasCompatibleSubscription =
    !!subscription?.payment.method?.expiry_year && !!subscription?.payment.method?.expiry_month
      ? isCreditCardExpired(
          subscription.payment.method.expiry_year,
          subscription.payment.method.expiry_month
        )
      : false;

  return { hasCompatibleSubscription };
};

// determines whether the subscription list page can display expiring payment banner
export const useSubscriptionListExpiringPaymentV2 = ({
  subscriptions
}: {
  subscriptions: SubscriptionDetailsV2Response[] | undefined;
}) => {
  const targetSubscription = subscriptions?.find(
    (sub) => hasExpiringPaymentV2(sub).hasCompatibleSubscription
  );

  return {
    hasCompatibleSubscription: Boolean(targetSubscription),
    paymentMethodId:
      targetSubscription && targetSubscription.payment.method
        ? getPaymentMethodId(targetSubscription.payment.method)
        : undefined
  };
};
